import React from 'react'
import { Link, StyleProps } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import GenerateLogo from '@assets/images/logo-ft-generate-dark.svg?react'
import { useGetDefaultAuthorRoute } from '@pages/author-v2/author-v2-hooks'

const styles = {
  logoContainer: {
    textDecoration: 'none',
    height: 56,
    display: 'flex',
    alignItems: 'center',
    marginTop: -0.5,
    '& svg': {
      height: 48,
    },
  },
} satisfies StyleProps

const Logo = (props: { onClear: () => void }) => {
  const defaultRoute = useGetDefaultAuthorRoute()
  return (
    <Link
      component={RouterLink}
      to={defaultRoute}
      onClick={props.onClear}
      sx={styles.logoContainer}
      aria-label="Go to Finetune Generate home page"
    >
      <GenerateLogo data-testid="finetune-logo" />
    </Link>
  )
}

export default Logo
